<template>
  <div class="bg-gray-100 p-4">
    <p class="font-raleway font-bold text-2xl text-mi-blue-500 uppercase">
      Voorziening toevoegen
    </p>
    <FormulateForm
      class="login-form flex-col flex"
      @submit="submitVoorziening"
      v-model="values"
    >
      <FormulateInput
        type="select"
        name="voorziening_type"
        validation="required"
        value="onbekend"
        input-class="mi-input"
        label-class="mi-label"
        :options="this.options_services.map(this.shorten_label)"
        label="Type voorziening *"
        :validation-messages="{
          required: 'Type voorziening is verplicht'
        }"
      />
      <FormulateInput
        type="select"
        name="ondergrond_type"
        value="onbekend"
        validation="required"
        input-class="mi-input"
        label-class="mi-label"
        :options="this.options_substrates.map(this.shorten_label)"
        label="Type ondergrond *"
        :validation-messages="{
          required: 'Type ondergrond is verplicht'
        }"
      />
      <FormulateInput
        type="select"
        multiple="true"
        name="sporten"
        validation="required"
        input-class="mi-input"
        label-class="mi-label"
        :options="this.options_sports.map(this.shorten_label)"
        label="Sporten *"
        :validation-messages="{
          required: 'Minimaal 1 sport is verplicht'
        }"
      />

      <FormulateInput
        type="submit"
        label="Voeg toe"
        class="mt-4"
        :input-class="'ml-2 mb-4 bg-gray-100  text-blue-700 font-semibold  py-2 px-4 border  rounded ' + (waiting_on_save ? 'border-gray-600 cursor-not-allowed' : 'border-mi-blue-400 hover:bg-mi-blue-400 hover:text-white hover:border-transparent')"
        :disabled="waiting_on_save"
      />
    </FormulateForm>
    {{ error_msg }}
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AddVoorziening",
  data() {
    return {
      values: {},
      postcode_error: true,
      error_msg: null,
      plaats: null,
      waiting_on_save: false
    };
  },
  computed: {
    ...mapGetters({
      options_services: "services_flattened",
      options_substrates: "substrates_flattened",
      options_sports: "sports_flattened"
    })
  },
  methods: {
    submitVoorziening: async function (data) {
      this.waiting_on_save = true;

      await this.$store.dispatch("loadAccommodatie", this.$route.params.id);
      let newVoorziening = {
        sporten: data["sporten"].map(sport => ({
          id: sport
        })),
        ondergrond: { id: data.ondergrond_type },
        voorziening_type: { id: data.voorziening_type },
        accommodatie: this.$store.state.backend_data.current_accommodatie
      };

      const [ok, msg] = await this.$store.dispatch(
        "addVoorziening",
        newVoorziening
      );

      if (ok) {
        this.$router.push({
          name: "Voorziening",
          params: {
            id: this.$store.state.backend_data.current_accommodatie.id,
            vzid: msg["msg"]
          }
        });
      } else {
        this.error_msg = msg;
      }

      this.waiting_on_save = false;
    },

    shorten_label: item => ({
      // TODO: this is a temp bug fix for size of field
      // We may be able to fix this with CSS
      // This impacts position of mobile nav
      ...item,
      label: item.label.slice(0, 20)
    })
  }
};
</script>

<style>
.mi-input {
  @apply border-gray-500 border rounded-sm px-2 py-1 w-full;
}

.mi-label {
  @apply text-sm font-bold;
}

.formulate-input-group-repeatable {
  @apply border-gray-500 border border-dashed m-4 p-4 bg-gray-200;
}

.formulate-input-group-repeatable-remove {
  @apply ml-2 mb-4 bg-gray-100  text-red-600 font-semibold  py-2 px-4 border border-red-400 rounded;
}

.formulate-input-group-repeatable-remove:hover {
  @apply bg-red-600 text-white border-transparent;
}

.formulate-input-element--button--label {
  @apply ml-2 mb-4 bg-gray-100  text-blue-700 font-semibold  py-2 px-4 border border-mi-blue-400 rounded;
}

.formulate-input-element--button--label:hover {
  @apply bg-mi-blue-400 text-white border-transparent;
}
</style>
